"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var channel_layout_values_1 = require("./channel-layout-values");
var channel_video_list_values_1 = require("./channel-video-list-values");
var compact_play_type_1 = require("./compact-play-type");
var compact_show_video_list_1 = require("./compact-show-video-list");
var info_position_values_1 = require("./info-position-values");
var layout_style_values_1 = require("./layout-style-values");
var main_action_style_types_1 = require("./main-action-style-types");
var main_item_type_values_1 = require("./main-item-type-values");
var show_info_values_1 = require("./show-info-values");
var show_media_type_values_1 = require("./show-media-type-values");
var title_position_values_1 = require("./title-position-values");
var versions_1 = require("./versions");
var navigation_arrows_behavior_1 = require("./navigation-arrows-behavior");
var thumbnail_buttons_behavior_1 = require("./thumbnail-buttons-behavior");
var navigation_arrows_position_1 = require("./navigation-arrows-position");
var show_expanded_video_list_titles_1 = require("./show-expanded-video-list-titles");
var expanded_theme_1 = require("./expanded-theme");
var text_alignment_values_1 = require("./text-alignment-values");
var load_more_button_type_values_1 = require("./load-more-button-type-values");
var video_end_options_1 = require("./video-end-options");
/* Change default settings here to modify defaults for new installations.
 * Existing installations will not be affected with these changes
 *
 * NOTE! This is not only place where default settings are coming from.
 * See build/partials/default-style-params.html and updateCSS function usage.
 * TODO: unify to one source of truth
 * */
exports.default = {
    booleans: {
        autoPlay: false,
        enableVideosSharing: true,
        showChannelCategories: false,
        showChannelShare: true,
        showChannelTitle: true,
        showChannelInfo: false,
        showSearch: true,
        showSignIn: false,
        showChannelTags: true,
        showChannelVideos: true,
        showVideoTitle: true,
        showFullInfo: true,
        showVideoPublisherInList: false,
        showVideoTitleInList: true,
        showVideoDescriptionInList: true,
        showVideoDurationInList: true,
        showTitleForMainItem: true,
        showPublisherForMainItem: true,
        showExpandedVideoInfo: true,
        enableExpandedVideosSharing: true,
        showExpandedSignIn: false,
        showExpandedChannelTitle: false,
        showExpandedVideoTitle: false,
        showExpandedVideoList: true,
        isSingleVideo: false,
        allowComments: false,
        stretchToFullWidth: false,
        useOptimalFontSizes: true,
    },
    numbers: {
        thumbnailSpacing: 0,
        containerMargins: 0,
        videoInfoPosition: info_position_values_1.INFO_POSITION_VALUES.ON_VIDEOS,
        showInfoAction: show_info_values_1.SHOW_INFO_VALUES.ON_MOUSE_OVER,
        layoutStyle: layout_style_values_1.LAYOUT_STYLE_VALUES.SQUARE,
        channelLayout: channel_layout_values_1.CHANNEL_LAYOUT_VALUES.CLASSIC,
        mainItemType: main_item_type_values_1.MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER,
        mainItemTitlePosition: title_position_values_1.TITLE_POSITION_VALUES.CENTER,
        videoListVisibility: channel_video_list_values_1.CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
        videosInRow: 4,
        mainItemOverlayOpacity: 35,
        thumbnailOverlayOpacity: 40,
        sliderHeight: 383,
        showMediaType: show_media_type_values_1.SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE,
        numberOfRows: 1,
        playType: compact_play_type_1.PLAY_TYPE_VALUES.IN_FRAME,
        compactShowVideoListType: compact_show_video_list_1.COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
        mainActionStyleType: main_action_style_types_1.MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
        settingsVersion: versions_1.APP_SETTINGS_VERSION_LATEST,
        showExpandedVideoListInfo: show_expanded_video_list_titles_1.SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES.ON_MOUSE_OVER,
        expandedTheme: expanded_theme_1.EXPANDED_THEME_VALUES.DARK,
        navigationArrowsBehavior: navigation_arrows_behavior_1.NAVIGATION_ARROWS_BEHAVIOR.ON_HOVER,
        thumbnailButtonsBehavior: thumbnail_buttons_behavior_1.THUMBNAIL_BUTTONS_BEHAVIOR.ALWAYS,
        navigationArrowsPosition: navigation_arrows_position_1.NAVIGATION_ARROWS_POSITION.OUTSIDE,
        textAlignment: text_alignment_values_1.TEXT_ALIGNMENT_VALUES.LEFT,
        loadMoreButtonType: load_more_button_type_values_1.LOAD_MORE_BUTTON_TYPE_VALUES.TEXT,
        videoEndOption: video_end_options_1.VIDEO_END_OPTIONS.SHOW_VIDEO_COVER,
    },
    fonts: {
        language: '',
    },
    colors: {
        compactMenuActionsColor: {
            themeName: 'color-1',
            value: 'rgba(255,255,255,1)',
        },
        compactMenuBackgroundColor: {
            themeName: 'color-5',
            value: 'rgba(65,65,65,1)',
        },
        mainButtonColor: {
            themeName: 'color-8',
        },
        thumbnailOverlayColor: {
            value: 'rgba(0,0,0,0.4)',
        },
        thumbnailButtonsColor: {
            value: 'rgba(255,255,255,1)',
        },
    },
    editMode: 'site',
};
//# sourceMappingURL=default-settings.js.map